import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { get } from 'lodash'
import ReportRoutes from '../Report'
import { setCurrentClient } from '../../actions/client'
import { fetchHomeDetail, setCurrentHomeDetail } from '../../actions/home'
import { selectClientFetchId } from '../../store/selectors/client'
import { selectHomeIsErrored } from '../../store/selectors/home'
import { getParsedJWT } from '../../auth'
import { fullStoryIdentify } from '../../helpers/tagManager'

import Loading from '../../Components/shared/Loading/LoadingApp'

export const BUYER_DIR = 'buy'
export const HOMEOWNER_DIR = 'home'
export const MARKETS_DIR = 'markets'

const wrapPathWithProps = ({ rootDir, match, location }, dir, id) => {
  const clientId = id || match.params.clientId

  if (!rootDir || !dir || !clientId) {
    return '/'
  }

  let path = `${rootDir}/${clientId}/${dir}`

  if (match.params.extra) {
    path += match.params.extra
  }

  if (location) {
    path += location.search.replace('cct=true', '').replace(/\?$/, '')
    path += location.hash
  }

  return path
}

const OldHomeRedirect = props => {
  const homeId = get(props, 'match.params.homeId')

  const dispatch = useDispatch()
  const clientId = useSelector(selectClientFetchId)
  const homeError = useSelector(selectHomeIsErrored)

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (homeId) {
      dispatch(setCurrentClient(null))
      dispatch(setCurrentHomeDetail(homeId))
      dispatch(fetchHomeDetail(homeId))
      setMounted(true)
    }
  }, [dispatch, homeId])

  if (homeId && mounted && homeError) {
    return <Redirect to='/not-found' />
  }

  if (homeId && mounted && clientId) {
    return (
      <Redirect
        to={wrapPathWithProps(props, `${HOMEOWNER_DIR}/${homeId}`, clientId)}
      />
    )
  }
  return <Loading />
}
const OldMarketsRedirect = props => (
  <Redirect to={wrapPathWithProps(props, MARKETS_DIR)} />
)
const OldBuyerRedirect = props => (
  <Redirect to={wrapPathWithProps(props, BUYER_DIR)} />
)

const propTypes = {
  rootDir: PropTypes.string,
}

const App = ({ rootDir }) => {
  useEffect(() => {
    fullStoryIdentify(getParsedJWT())
  }, [])

  return (
    <Switch>
      <Route
        exact
        path={`${rootDir}/${BUYER_DIR}`}
        render={() => <Redirect to='/' />}
      />
      <Route
        exact
        path={`${rootDir}/${HOMEOWNER_DIR}`}
        render={() => <Redirect to='/' />}
      />
      <Route
        path={`${rootDir}/${HOMEOWNER_DIR}/:homeId([0-9A-Fa-f]{24})`}
        render={props => <OldHomeRedirect rootDir={rootDir} {...props} />}
      />
      <Route
        path={`${rootDir}/${BUYER_DIR}/:clientId([-0-9A-Fa-f]{36})/${MARKETS_DIR}:extra(.*)`}
        render={props => <OldMarketsRedirect rootDir={rootDir} {...props} />}
      />
      <Route
        path={`${rootDir}/${BUYER_DIR}/:clientId([-0-9A-Fa-f]{36})`}
        render={props => <OldBuyerRedirect rootDir={rootDir} {...props} />}
      />
      <Route
        path={`${rootDir}/:clientId([-0-9A-Fa-f]{36}|initialize)`}
        component={ReportRoutes}
      />
      <Redirect to='/' />
    </Switch>
  )
}

App.propTypes = propTypes
export default App
